export const PRIVILEGE_MANAGE_CHALLENGES = 'manageChallenges';
export const PRIVILEGE_MANAGE_ASSESSMENTS = 'manageAssessments';
export const PRIVILEGE_DECIDE_ON_CANDIDATES = 'decideOnCandidates';

export const ALL_PRIVILEGES = [
  {
    id: PRIVILEGE_MANAGE_ASSESSMENTS,
    name: 'Manage Assessments',
    shortName: 'Manage',
    info: 'Ability to create, modify, and delete assessments',
    icon: 'tasks',
    icon2: 'pencil',
    category: 'Assessments',
    toggle: false,
  },
  {
    id: PRIVILEGE_MANAGE_CHALLENGES,
    name: 'Manage Challenges',
    shortName: 'Manage',
    info: 'Ability to create, modify, and delete challenges',
    icon: 'code',
    icon2: 'pencil',
    category: 'Challenges',
    toggle: false,
  },
  {
    id: PRIVILEGE_DECIDE_ON_CANDIDATES,
    name: 'Decide On Candidates',
    shortName: 'Decide',
    info: 'Ability to decide whether candidates are approved or rejected',
    icon: 'thumbs-up',
    icon2: 'pencil',
    category: 'Candidates',
    toggle: true,
  },
];

// enables hash access
ALL_PRIVILEGES.forEach((p) => {
  ALL_PRIVILEGES[p.id] = p;
});

const PRIVILEGE_WITH_VALUE = /^(\w+):(\w+)$/;

/**
 * Checks to see if the given model has a privilege.
 *
 * @param {*} model - Model to check. Will look at model.privileges if present
 * @param {string} privilege - Name of privilege. Can also be in the form of "name:value" to check for a specific value
 * @param {boolean|string?} value - If not provided, just check to see if the privilege is truthy and not 'none'. Otherwise, check to see if the privilege matches the value exactly
 * @returns {boolean}
 */
export function checkPrivilege(model, privilege, value) {
  if (PRIVILEGE_WITH_VALUE.test(privilege)) {
    [, privilege, value] = privilege.match(PRIVILEGE_WITH_VALUE);
  }

  const privileges = model.privileges || model || {};

  if (value === undefined) {
    return !!privileges[privilege] && privileges[privilege] !== 'none';
  } else {
    return privileges[privilege] === value;
  }
}
